import styled, { css } from 'styled-components';
import Tooltip from '../Tooltip/tooltip.index';

interface InputContainerProps {
    isFocused: boolean;
    isFilled: boolean;
    hasErrors: boolean;
}

export const InputContainer = styled.div<InputContainerProps>`
    display: flex;
    align-items: center;
    background: #232129;
    border: 2px solid #232129;
    border-radius: 10px;
    padding: 16px;
    width: 100%;
    & + div {
        margin-top: 8px;
    }
    ${(props) =>
        props.hasErrors &&
        css`
            border-color: #c53030;
        `}

    ${(props) =>
        props.isFocused &&
        css`
            color: #ff9000;
            border-color: #ff9000;
        `}

    ${(props) =>
        props.isFilled &&
        css`
            color: #ff9000;
        `}
    
    input {
        flex: 1;
        background: transparent;
        border: 0;
        color: #f4ede8;
        &::placeholder {
            color: #666360;
        }
    }
    svg {
        margin-right: 16px;
    }
`;

export const Error = styled(Tooltip)`
    height: 20px;
    margin-left: 16px;

    svg {
        margin: 0;
    }
    span {
        background: #c53030;
        color: #fff;

        &::before {
            border-color: #c53030 transparent;
        }
    }
`;
